/* @ngInject */
export default function nl2brFilter() {
  return function(rawText) {
    if (!rawText) return rawText
    return rawText.replace(/\n\r?/g, '<br><br>')
  }
}
